import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import roleActions from '../../redux/qbrole/actions'

// subcomponent
import HeadBar from './headbar'
import ListRoles from './list_roles'
import Paginate from './paginate'
import ModalRoleInfo from './modal_role_info'
import ModalConfirmDelete from './modal_confirm_delete'

class RoleManagement extends Component {
    componentDidMount(){
        this.props.loadListRoles({})
    }

    render() {
        const { height } = this.props

        return (
            <div className="RoleManagement">
                <div className="MainCard" style={{ minHeight: height - 100 }}>
                    <HeadBar />
                    <ListRoles />
                    <Paginate />

                    <ModalConfirmDelete />
                    <ModalRoleInfo />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.app,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadListRoles: params => {
            dispatch(roleActions.action.loadListRoles(params))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RoleManagement)